module.exports = __webpack_public_path__ + "static/media/my-plans-icon.f8a257f9.svg";